<template>
  <div>
    <detailHeader v-if="$route.name == 'serviceDetail'"></detailHeader>
    <!-- 服务单列表 -->
    <section :class="{ 'serviceDetail': $route.name == 'serviceDetail' }">
      <!-- 按服务单号切换，内容区只显示当前服务单 -->
      <el-tabs v-if="tableData.length" v-model="activeServiceSn" type="card" class="service-tabs"
        @tab-click="changeServiceTab">
        <el-tab-pane v-for="orderItem in tableData" :key="orderItem.service_sn"
          :label="orderItem.service_sn + '（' + orderItem.status_name + '）'" :name="orderItem.service_sn">
        </el-tab-pane>
      </el-tabs>
      <!-- 开始处理 -->
      <div style="margin-bottom: 24px">
        <el-button type="primary" class="primary" @click="optionServiceStart" v-if="status == '待开始'">
          {{ $t("message.startProcessing") }}
        </el-button>
        <el-button type="primary" v-else>
          {{ status }}
        </el-button>
        <!-- 删除 -->
        <el-button type="danger" class="fr dark" @click="showDelete" v-if="isAuth(589)">
          {{ $t("message.delete") }}
        </el-button>
        <!-- 修改数量 -->
        <el-button type="danger" class="fr" @click="showUpdateComplete" v-if="isAuth(702) && status == '已完成'">
          {{ $t("message.updateQuantity") }}
        </el-button>
      </div>
      <div class="footer">
        <div class="footerContainer">
          <div class="table">
            <!-- 无数据显示 -->
            <div class="noData" v-if="tableData == false">暂无数据</div>
            <!-- 当前选中的服务单 -->
            <div class="detail" v-for="orderItem in currentServiceList" :key="orderItem.service_sn">
              <div class="head">
                <div class="row">
                  <!-- 是否显示 -->
                  <div class="show" @click="isShow(orderItem)">
                    <el-button size="mini">{{ !orderItem.show ? '收起' : '展开' }}
                      <i :class="orderItem.show ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
                    </el-button>
                  </div>
                  <!-- 提出时间 -->
                  <div class="item">
                    {{ $t("message.forwardTime") }}：{{ orderItem.created_at }}
                  </div>
                  <!-- 服务单号: -->
                  <div class="item order">
                    {{ $t("message.serviceOrderNumber") }}：

                    <span class="acli">
                      {{ orderItem.service_sn }}
                    </span>

                    <!-- 客户属性 -->
                    <span style="width: 80px;">
                      <attributeName :name="orderItem.attribute_name" />
                    </span>
                    <i class="el-icon-copy-document" @click="copy(orderItem.service_sn)"></i>
                  </div>
                  <!-- 提出人 -->
                  <div class="item">
                    {{ $t("message.forwarder") }}：
                    {{ orderItem.created_admin != null ? orderItem.created_admin.realname : '' }}
                  </div>
                  <!-- 服务单处理 -->
                  <div class="item">
                    {{ $t('message.serviceOperator') }}: {{ orderItem.admin_admin != null ?
                      orderItem.admin_admin.realname
                      : '' }}
                  </div>
                  <!-- 要求完成时间时间 -->
                  <div class="item">
                    {{ $t('message.requiredCompletionTime') }}: {{ orderItem.need_complete_at }}
                  </div>
                  <!-- 服务单类型 -->
                  <div class="item">
                    <div>
                      <el-button :type="setType(orderItem.cate_id)" :class="{ primary: orderItem.cate_id == 2 }">{{
                        orderItem.cate_name }}</el-button>
                    </div>
                  </div>
                </div>
                <!-- 统计 -->
                <div class="total">
                  <!-- 总计需要操作： -->
                  <div class="label">{{ $t("message.totalNeedsOperation") }}：</div>
                  <div class="item" v-for="(item, index) in orderItem.total" :key="index">
                    {{ item.name }}: <span>{{ item.should }}</span></div>
                </div>
              </div>
              <div class="orderDetailOpt" v-show="!orderItem.show">
                <ol>
                  <!-- 选择 -->
                  <li class="flex05">{{ $t("message.choose") }}</li>
                  <!--  订单号-->
                  <li class="flex15">
                    {{ $t("message.orderNumber") }}
                  </li>
                  <!-- 番号 -->
                  <li class="flex05">{{ $t("message.mash") }}</li>
                  <!--照片-->
                  <li>
                    {{ $t("message.pic") }}
                  </li>
                  <!-- 业务编辑商品属性 -->
                  <li class="flex15">{{ $t("message.theBusinessEditsTheCommodityProperties") }}</li>
                  <!-- 购买信息 -->
                  <li>{{ $t("message.purchaseInformation") }}</li>
                  <!-- 附加服务 -->
                  <li class="flex15">{{ $t("message.additionalServices") }}</li>
                  
                  <!-- 担当备注 -->
                  <li class="flex15">
                    {{ $t("message.responsibleForRemarks") }}
                  </li>
                  <!-- 核查员备注 -->
                  <li class="flex15">
                    {{ $t("message.verifierSNotes") }}
                  </li>
                  <!-- 操作内容-需要操作数量 -->
                  <li class="flex5">
                    操作内容-需要操作数量-实际操作数量
                  </li>
                  <!-- 标签信息：服务单直接展示订单标签，并提供核对和打印入口。 -->
                  <li class="flex2 tagCell">标签信息</li>
                  <!-- 检品组长备注 -->
                  <li class="flex15">
                    {{ $t("message.inspectionLeaderRemark") }}
                  </li>
                  <!-- 操作人员备注 -->
                  <li class="flex15">
                    {{ $t("message.operationPersonnelRemark") }}
                  </li>
                  <!-- 状态 -->
                  <li>{{ $t("message.status") }}</li>
                </ol>
                <ul v-for="(goodsItem, indexs) in orderItem.option_service_detail" :key="indexs">
                  <!-- 选择 -->
                  <li class="flex05">
                    <el-checkbox v-model="goodsItem.checked"></el-checkbox>
                  </li>
                  <!--  订单号-->
                  <li class="flex15">
                    <router-link :to="'/orderPaymentDetail?order_sn=' + goodsItem.order_detail.order_sn" target="_blank"
                      class="a-link">{{ goodsItem.order_detail.order_sn }}</router-link>
                  </li>
                  <li class="flex05">
                    {{ goodsItem.order_detail.sorting }}
                  </li>
                  <!--照片-->
                  <li>
                    <div>
                      <div class="img">
                        <el-popover placement="right" width="300" trigger="hover">
                          <img :src="goodsItem.order_detail.pic" alt="" style="width: 300px; height: 300px" />

                          <a :href="goodsItem.order_detail.link.goods_url" target="_blank" slot="reference">
                            <img :src="goodsItem.order_detail.pic" alt="" />
                          </a>
                        </el-popover>
                      </div>
                    </div>
                  </li>
                  <!-- 商品属性 -->
                  <li class="flex15">
                    <div class="template">
                      <p v-for="(skuItem, skuIndex) in goodsItem
                        .order_detail.detail_y" :key="skuIndex">
                        <span>{{ skuItem.key }}:</span>
                        <span>{{ skuItem.value }}</span>
                      </p>
                    </div>
                  </li>
                  <!-- 购买信息 -->
                  <li>
                    <div class="template">
                      <p>数量：{{ goodsItem.order_detail.confirm_num }}</p>
                      <p>单价：{{ goodsItem.order_detail.confirm_price }}</p>
                    </div>
                  </li>
                  <!-- 附加服务 -->
                  <li class="flex15">
                    <div class="template">
                      <el-tag v-if="Number(goodsItem.order_detail.is_fba_pre) === 1" type="success" size="mini">
                        标签前置处理
                      </el-tag>
                      <el-tooltip placement="bottom">
                        <div slot="content">
                          <div class="row" v-for="(opti, optiIndex) in goodsItem
                            .order_detail.option" :key="optiIndex" style="margin-bottom: 3px">
                            <p>
                              {{ optiIndex + 1 }}.{{ opti.name }}:
                              <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price }}元</span>
                              <span v-else> {{ opti.price }}% </span>
                            </p>
                          </div>
                        </div>
                        <div style=" max-height: 150px; overflow: hidden;">
                          <div class="row" v-for="(opti, optiIndex) in goodsItem
                            .order_detail.option" :key="optiIndex">
                            <p>
                              {{ optiIndex + 1 }}.{{ opti.name }}:
                              <span v-if="opti.price_type != 1">{{ opti.num }}</span>
                              <span v-else> {{ opti.price }}% </span>
                            </p>
                          </div>
                        </div>
                      </el-tooltip>
                    </div>
                  </li>
               
                  <!-- 担当备注 注:担当就是业务员-->
                  <li class="flex15">
                    {{ goodsItem.order_detail.y_remark }}
                  </li>
                  <!-- 核查员备注 注:核查员就是配货-->
                  <li class="flex15">
                    {{ goodsItem.order_detail.p_remark }}
                  </li>
                  <!--  操作内容-需要操作数量-实际操作数量 -->
                  <li class="flex5">
                    <div class="template option">
                      <div class="row" v-for="(extra, extraIndex) in goodsItem.extra_options" :key="extraIndex">
                        <div class="label">{{ extra.name }}:</div>
                        <div class="num">{{ extra.should }}</div>
                        <div class="input">
                          <el-input v-model="extra.complete" placeholder="数量" @input="handleInput(extra)"
                            :readonly="goodsItem.status_name != '服务处理中'"></el-input>
                        </div>
                      </div>
                    </div>
                  </li>
                     <!-- 标签信息 -->
                     <li class="flex2 tagCell tagListCell">
                    <div class="tag-content" v-for="(tag, tagIndex) in getOrderTags(goodsItem)" :key="tag.id || tagIndex">
                      <div class="tag-actions">
                        <el-button type="danger" size="mini" @click="checkTag(goodsItem, tag)">核对</el-button>
                        <!-- 未打印标签使用success颜色，已打印标签保留原有颜色。 -->
                        <el-button :type="tag.is_print ? 'primary' : 'success'" size="mini"
                          @click="printTag(goodsItem, tag)">
                          {{ tag.is_print ? '已打印' : '打印' }}
                        </el-button>
                      </div>
                      <div class="tag-record">
                        <div class="tag-field"><span class="tag-label">类别</span><span class="tag-value">{{ tag.type }}</span></div>
                        <div class="tag-field"><span class="tag-label">标签号</span><span class="tag-value">{{ tag.no }}</span></div>
                        <div class="tag-field"><span class="tag-label">商品码</span><span class="tag-value">{{ tag.goods_no }}</span></div>
                        <div class="tag-field">
                          <span class="tag-label">标签数量</span>
                          <span class="tag-value tag-count-value">
                            <span>{{ tag.num }}</span>
                            <!-- 纯文本标与配送单一致，放在标签数量行并通过 hide 模式打印。 -->
                            <el-button type="primary" size="mini" @click="printTag(goodsItem, tag, 'hide')">
                              {{ $t("message.plainTextLabel") }}
                            </el-button>
                          </span>
                        </div>
                        <div class="tag-field"><span class="tag-label">文本描述1</span><span class="tag-value">{{ tag.text_line_one }}</span></div>
                        <div class="tag-field"><span class="tag-label">文本描述2</span><span class="tag-value">{{ tag.text_line_two }}</span></div>
                        <div class="tag-field"><span class="tag-label">文本描述3</span><span class="tag-value">{{ tag.text_line_three }}</span></div>
                        <div class="tag-field"><span class="tag-label">文本描述4</span><span class="tag-value">{{ tag.text_line_four }}</span></div>
                      </div>
                    </div>
                  </li>
                  <!-- 检品组长备注 -->
                  <li class="flex15">
                    <optionServiceRemark :detail="goodsItem" field="leader_remark" />
                  </li>
                  <!-- 操作人员备注 -->
                  <li class="flex15">
                    <optionServiceRemark :detail="goodsItem" field="mechanic_remark" />
                  </li>
                  <!-- 状态 -->
                  <li>
                    <div>
                      <span>
                        {{ goodsItem.status_name
                        }}
                      </span>
                      <p v-if="goodsItem.status_name == '服务完成'"> {{ $t("message.completionTime") }}：{{
                        goodsItem.complete_at }}</p>
                    </div>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn">
        <div class="left">
          <!-- 全选 -->
          <el-checkbox v-model="checked" @change="handleCheckAllChange">
            {{ $t("message.allChecked") }}
          </el-checkbox>
          <!-- 变更处理人 -->
          <el-button type="primary" class="primary" @click="changeHandler" v-if="isAuth(590) && status == '待开始'">
            {{ $t('message.changeHandler') }}
          </el-button>
          <!-- 服务单拆分 -->
          <el-button type="primary" class="primary" @click="serviceOrderSplit" v-if="status != '已完成' && isAuth(202)">
            {{ $t('message.serviceOrderSplit') }}
          </el-button>
          <!-- 权限756：仅待处理和处理中允许变更商品的需要操作数量。 -->
          <el-button type="primary" class="primary" @click="showUpdateShould"
            v-if="isAuth(756) && (status == '待开始' || status == '已开始操作')">
            {{ $t('message.changeRequiredOperationQuantity') }}
          </el-button>
        </div>
        <div class="right" v-if="status != '已完成'">
          <!-- 临时保存 -->
          <el-button type="success" @click="optionServiceCompleteSave(1)" v-if="isAuth(591) && status != '待开始'">
            {{ $t('message.temporaryStorage') }}
          </el-button>
          <!-- 操作完了 -->
          <el-button type="primary" @click="optionServiceCompleteSave(0)" v-if="isAuth(591) && status != '待开始'">
            {{ $t('message.operationCompleted') }}
          </el-button>
        </div>
      </div>
      <!-- 底部 -->
      <div class="bottom">
        <div class="bottom-left">
          <!-- 注意事项 -->
          <div class="label">
            {{ $t('message.mattersNeedingAttention') }}:
          </div>
          <div class="text">
            <el-input type="textarea" v-model="detail.remark" disabled resize="none"></el-input>
          </div>
        </div>
        <div class="bottom-right">
          <!-- 服务单附件 -->
          <div class="label">
            {{ $t('message.serviceOrderAttachment') }}:
          </div>
          <div class="file">
            <div class="file-list">
              <a :href="item" target="_blank" rel="noopener noreferrer" v-for="(item, index) in detail.file"
                :key="index" :title="item">
                <i class="el-icon-folder-checked"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 删除弹框 -->
    <delDialogVisible ref="delDialogVisible" />
    <!-- 变更服务单操作人员-->
    <changeHandler ref="changeHandler" />
    <!-- 修改数量弹窗 -->
    <updateComplete ref="updateComplete" />
    <!-- 服务单拆分弹窗 -->
    <serviceOrderSplit ref="serviceOrderSplit" />
    <!-- 标签补打原因：已打印标签再次打印前沿用付款订单的原因登记流程。 -->
    <PrintAgain ref="printAgain" :order-detail-tag-id="printReasonTagId" :save-handler="savePrintReason"
      @print="printTagCopies" @cancel="cancelPrintReason" />
    <!-- 订单标签核对弹窗：使用订单标签扫码接口，与配送单核对隔离。 -->
    <orderTagScanList ref="orderTagScanList" />
    <!-- 隐藏打印区域：使用订单详情相同的标签模板，打印时临时渲染到页面。 -->
    <div v-show="false">
      <div v-if="printTagData" ref="tagPrint">
          <tabPrint v-for="item in tabPrintNum" :key="item" :printTagData="printTagData" :isExpress="printMode" />
      </div>
    </div>
  </div>
</template>
<script>
import detailHeader from "@/components/header/detailHeader";
import delDialogVisible from './delDialogVisible'
import changeHandler from './changeHandler'
import updateComplete from './updateComplete'
import serviceOrderSplit from './serviceOrderSplit'
// 标签补打原因弹框和标签打印模板与付款订单详情共用，保持打印格式一致。
import PrintAgain from '@/views/orderDetail/components/printAgain'
import tabPrint from '@/components/Printedsheet/tag/tabPrint.vue'
import orderTagScanList from '@/components/common/orderTagScanList'

export default {
  components: {
    detailHeader,
    delDialogVisible,
    changeHandler,
    updateComplete,
    serviceOrderSplit,
    PrintAgain,
    tabPrint,
    orderTagScanList
  },
  data() {
    return {
      start: false,
      status: '',
      isDelete: false,
      detail: {},
      datas: {
        page: 1,
        // 详情页没有分页控件，一次取回匹配条件下的全部服务单。
        pageSize: 9999999,
        status: '',
        datetimeStart: "",
        datetimeEnd: "",
        user_id: "",
        order_sn: "",
        express_no: this.$route.query.express_no || "",
        purchase_no: this.$route.query.purchase_no || "",
        order_sn: "",
        service_sn: this.$route.name == 'serviceDetail' ? this.$route.query.service_sn : '',
        cate_id: this.$route.query.cate_id || '',
      },
      checkedList: [],
      tableData: [],
      activeServiceSn: '',
      checked: false,
      // 当前待打印标签及补打参数；打印完成或取消后会清空。
      printTagData: null,
      printReasonTagId: '',
      tabPrintNum: 1,
      printMode: '',

    };
  },
  computed: {
    currentService() {
      return this.tableData.find(item => item.service_sn == this.activeServiceSn) || null
    },
    // 使用数组保留原模板中的 orderItem 数据结构，同时确保只渲染一个服务单。
    currentServiceList() {
      return this.currentService ? [this.currentService] : []
    }
  },
  created() {
    if (this.$route.name == 'serviceDetail') {
      this.optionServiceList()
    }
  },
  methods: {
    // 服务单接口的标签可能位于服务明细或订单明细，统一兼容两种返回层级。
    getOrderTags(goodsItem) {
      const detail = goodsItem && goodsItem.order_detail
      if (Array.isArray(goodsItem && goodsItem.order_detail_tag)) return goodsItem.order_detail_tag
      if (Array.isArray(detail && detail.order_detail_tag)) return detail.order_detail_tag
      return []
    },
    // 服务单标签核对使用订单标签扫码接口，并展示该标签的扫码历史。
    checkTag(goodsItem, tag) {
      this.$refs.orderTagScanList.open(goodsItem.order_detail.order_sn, tag.id)
    },
    // 首次打印直接打印并通知服务端；已打印标签先登记补打原因；mode=hide 时打印纯文本标。
    printTag(goodsItem, tag, mode = '') {
      this.printTagData = JSON.parse(JSON.stringify(tag))
      this.printMode = mode
      this.tabPrintNum = 1
      if (tag.is_print) {
        this.printReasonTagId = tag.id
        this.$refs.printAgain.dialogVisible = true
        return
      }
      this.printTagCopies(1)
      this.$api.orderApi.printTag({
        order_detail_tag_id: tag.id,
        order_detail_id: goodsItem.order_detail.id,
        type: tag.type,
        no: tag.no
      }).then(() => this.$set(tag, 'is_print', 1)).catch(error => {
        this.$message.error(error && error.msg ? error.msg : '标签打印失败')
      })
    },
    // 按申请数量渲染标签模板并调用浏览器打印插件。
    printTagCopies(num) {
      this.tabPrintNum = Number(num) || 1
      this.$nextTick(() => {
        this.$print(this.$refs.tagPrint)
        this.printTagData = null
        this.tabPrintNum = 1
      })
    },
    // 取消补打原因登记时清理临时打印状态，避免下次打开残留数据。
    cancelPrintReason() {
      this.printTagData = null
      this.printReasonTagId = ''
      this.tabPrintNum = 1
    },
    // 保存已打印标签的补打原因，接口成功后由 PrintAgain 触发实际打印。
    savePrintReason(data) {
      return this.$api.orderApi.printReasonStore(data)
    },
    // 服务单类型-按钮类型
    setType(type) {
      switch (type) {
        case 1:
          return 'info'
          break;
        case 2:
          return 'primary'
          break;
        case 3:
          return 'success'
          break;
        case 4:
          return 'warning'
          break;
        case 5:
          return 'danger'
          break;
        default:
          return ''
          break;
      }
    },
    // 获取列表
    optionServiceList() {
      this.$api.optionServiceApi.optionServiceList(this.datas).then((res) => {
        const list = res.data.data
        this.totalize(list)
        // 首次默认第一条；刷新后若原服务单仍存在，则保持当前选中项。
        if (!list.some(item => item.service_sn == this.activeServiceSn)) {
          this.activeServiceSn = list.length ? list[0].service_sn : ''
        }
        this.setCurrentService()
      });
    },
    // Tab 切换后更新最初版详情页使用的当前服务单数据。
    changeServiceTab(tab) {
      this.activeServiceSn = tab.name
      this.setCurrentService()
    },
    setCurrentService() {
      this.detail = this.tableData.find(item => item.service_sn == this.activeServiceSn) || {}
      this.status = this.detail.status_name || ''
      this.checked = this.detail.option_service_detail
        ? this.detail.option_service_detail.every(item => item.checked)
        : false
    },
    //计算总数
    totalize(list) {
      // 为所有商品设置单选框参数
      list.forEach((orderItem) => {
        orderItem.total = []
        orderItem.checked = false
        orderItem.option_service_detail.forEach((item) => {
          item.checked = false
          if (item.extra_options != null) {
            // 过滤掉should为0的项
            item.extra_options = item.extra_options.filter(extraItem => extraItem.should != 0)
            item.extra_options.forEach(extraItem => {
              // 未完成数量
              if (!extraItem.complete) {
                extraItem.complete = extraItem.should - 0
              }

              // 总数量
              let existingItem = orderItem.total.find(totalItem => totalItem.name == extraItem.name)
              if (existingItem) {
                existingItem.should += extraItem.should - 0
              } else {
                orderItem.total.push({
                  name: extraItem.name,
                  should: extraItem.should - 0
                })
              }
            })
            // console.log(item.cate_name, item.order_detail.option, orderItem.status_name)
            if (item.cate_name == '普通服务' && item.order_detail.option.some(option => option.name == 'FBA贴标') && orderItem.status_name == '已开始操作') {
              item.extra_options.forEach(extraItem => {
                extraItem.complete = 0
              })
            }
          }
        })
      });
      this.tableData = list;
      this.$forceUpdate()
    },
    // 开始处理
    optionServiceStart() {
      this.$api.optionServiceApi.optionServiceStart({ service_sn: this.detail.service_sn }).then((res) => {

        this.$message.success(res.msg)
        this.optionServiceList()
      })
    },
    //显示删除
    showDelete() {
      const detail_ids = []
      this.detail.option_service_detail.forEach(item => {
        if (item.checked) {
          detail_ids.push(item.id)
        }
      })
      if (detail_ids.length == 0) {
        this.$message.error('请选择要删除的商品')
        return
      }
      this.$refs.delDialogVisible.delDialogVisible = true
      this.$refs.delDialogVisible.delateData = {
        service_sn: this.detail.service_sn,
        deleted_reason: '',
        detail_ids
      }
    },
    // 变更服务单操作人
    changeHandler() {
      this.$refs.changeHandler.usableAdminList()
      this.$refs.changeHandler.dialogVisible = true
      this.$refs.changeHandler.datas = {
        service_sn: this.detail.service_sn,
        adminId: this.detail.admin_id,
      }
    },
    //提交保存 是否临时保存,0-不是临时保存,1-是临时保存
    optionServiceCompleteSave(type) {
      let datas = {
        is_tamp: type,
        serviceDetail: [],
      }
      this.detail.option_service_detail.forEach(item => {
        if (item.checked) {
          datas.serviceDetail.push({
            id: item.id,
            extra_options: item.extra_options
          })
        }
      })
      if (datas.serviceDetail.length == 0) {
        this.$message.error('请选择要处理的商品')
        return
      }
      if (type == 0) {
        let hasEmptyComplete = false
        for (const item of datas.serviceDetail) {
          for (const extraItem of item.extra_options) {
            if (extraItem.complete === '') {
              hasEmptyComplete = true
              break
            }
          }
          if (hasEmptyComplete) {
            break
          }
        }
        if (hasEmptyComplete) {
          this.$message.error('请输入处理数量')
          return
        }
        this.$confirm(
          '是否完成当前服务单，操作后服务单无法取消，请确认后操作',
          // 提示
          this.$t("message.prompt"),
          {
            // 确定
            confirmButtonText: this.$t("message.ok"),
            // 取消
            cancelButtonText: this.$t("message.cancel"),
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            this.$api.optionServiceApi.completeSave(datas).then((res) => {
              this.$message.success(res.msg)
              this.checked = false
              // this.isAllComplete()
              this.optionServiceList()
            })
          })
          .catch(() => { });
      } else {
        this.$api.optionServiceApi.completeSave(datas).then((res) => {
          this.$message.success(res.msg)
          this.checked = false
          this.optionServiceList()
        })
      }
    },
    // 订单是否全部完成
    isAllComplete() {
      this.$api.optionServiceApi.optionServiceList(this.datas).then((res) => {
        let flag = res.data.data.every(item => item.complete_at);
        if (flag) {
          if (this.$route.name == 'serviceDetail') {
            window.close()
          }
          return true
        }
      })

    },
    // 是否显示商品列表
    isShow(data) {
      data.show = !data.show;
      this.$forceUpdate();
    },
    handleInput(item) {
      // 将输入值转换为数字，去除所有非数字字符
      let value = item.complete.replace(/\D/g, '');
      // 如果输入为空，则清空
      if (value === '') {
        item.complete = '';
      } else {
        // 转换为数字
        const number = parseInt(value, 10);
        // 确保是正整数
        if (isNaN(number) || number < 0) {
          item.complete = '';
        } else {
          // 不能大于should值
          const maxShould = parseInt(item.should, 10) || 0;
          if (number > maxShould) {
            item.complete = maxShould.toString();
          } else {
            item.complete = number.toString();
          }
        }
      }
      this.$forceUpdate()
    },
    // 已完成状态使用原弹窗修改实际完成数量。
    showUpdateComplete() {
      this.$refs.updateComplete.open('complete', [this.detail], this.detail.service_sn)
    },
    // 待处理/处理中只提交当前服务单已勾选的商品。
    showUpdateShould() {
      const currentOrder = JSON.parse(JSON.stringify(this.detail))
      currentOrder.option_service_detail = currentOrder.option_service_detail.filter(item => item.checked)
      const tableData = currentOrder.option_service_detail.length ? [currentOrder] : []

      if (!tableData.length) return this.$message.error(this.$t('message.operationDataIsNotSelected'))
      this.$refs.updateComplete.open('should', tableData, this.detail.service_sn)
    },
    // 全选
    handleCheckAllChange() {
      this.detail.option_service_detail.forEach(item => {
        item.checked = this.checked
      })
      this.$forceUpdate()
    },
    // 服务单拆分
    serviceOrderSplit() {
      let isChecked = this.detail.option_service_detail.some(item => item.checked)
      if (!isChecked) {
        this.$message.error('请选择要拆分的商品')
        return
      }
      this.$refs.serviceOrderSplit.optionServicePreview(this.detail)
      this.$refs.serviceOrderSplit.dialogVisible = true
    },
  },
};
</script>

<style lang='scss' scoped>
@import "@/css/mixin";

/deep/.is-disabled {
  .el-textarea__inner {
    background-color: #fff !important;
    color: #606266;
  }
}

.el-checkbox {
  transform: scale(1.5);
}

.serviceDetail {
  min-width: 1862px;
  padding: 24px;
}

section {
  position: relative;
  padding: 0;
  padding-top: 24px;
  // margin: 24px;

  background-color: #FFF;

  .header {
    padding: 0;
  }

  .headerContainer {
    background-color: #f6f6f6 !important;
    padding: 0 !important;

    .option {
      position: absolute;
      top: 24px;
      right: 24px;
      display: flex;

      .item {
        margin-left: 10px;
        cursor: pointer;
        background-color: #f56c6c;
        color: #fff;
        padding: 10px 15px;
        border-radius: 5px;
      }
    }
  }

  .footer {
    padding: 0;
    background-color: #f6f6f6 !important;

    .footerContainer {
      padding: 0;
    }
  }
}

.service-tabs {
  margin-bottom: 24px;

  /deep/ .el-tabs__header {
    margin-bottom: 0;
  }
}

.leftContainer {
  width: 100% !important;
  display: flex;
  flex-wrap: wrap;

  .Container {
    margin-right: 20px;
    margin-bottom: 20px;
    max-width: 200px;

    /deep/.el-date-editor {
      width: 200px;
    }
  }

  .time {
    margin-right: 20px;
  }
}

.table {
  ol {
    display: flex;
    font-size: 14px;
    height: 60px;
    background-color: #edeff4;
    color: #333;
    position: sticky;
    top: 0px;
    left: 240px;
    z-index: 99;


    li {
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 20px;

    }
  }

  ul {
    display: flex;
    border-bottom: 1px solid #e8e8e8;
    padding: 10px 0;
    font-size: 12px;
    transition: 0.25s;

    &:hover {
      background-color: #eee;
      cursor: pointer;
    }

    li {
      width: 100%;
      word-break: break-all;

      .template {
        text-align: left;
        width: 100%;

        .row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 6px;
          padding: 0 6px;

          &:nth-last-child(1) {
            margin-bottom: 0;
          }

          .num {
            color: #B4272D;
          }
        }
      }

      .option {
        .row {
          display: flex;
          line-height: 40px !important;
          margin-bottom: 12px;
          font-size: 22px;

          .label {
          }

          .input {
            width: 70px;
            margin: 0 10px;
          }

          .num {
            width: 50px;
            margin-right: 10px;

          }


        }
      }
    }

    .img {
      position: relative;

      img {
        width: 60px;
        height: 60px;
        border-radius: 4px;
      }


    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 3px;


  }

  .numberOfgoodsItem {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .time {
      display: flex;
      width: 70px;
    }
  }

  .flex05 {
    flex: 0.5;
    position: relative;

    a {
      position: absolute;
      right: 0;
      top: 0;
      height: 20px;
      width: 20px;
      background-color: #f56c6c;
      border-radius: 50%;
      line-height: 20px;
      text-align: center;
      color: #fff;
    }


  }

  .flex15 {
    flex: 1.3;
  }

  .flex2 {
    flex: 1.8;

    /deep/ .el-textarea__inner {
      height: 40px;
      padding: 0 2px;
      line-height: 18px;
    }
  }

  .flex5 {
    flex: 3;
  }

  .detail {
    margin-bottom: 12px;

    .head {
      padding: 0px 20px;
      border-radius: 4px 4px 0px 0px;
      background-color: #545467;
      font-size: 14px;
      color: #fff;

      .row {
        display: flex;
        padding: 12px 0;
        border-bottom: 1px solid #87879F;

        .checkbox {
          line-height: 40px;
          margin-right: 20px;
        }

        .show {
          cursor: pointer;
          font-size: 30px;
          display: flex;
          justify-content: center;
          align-items: center;

          /deep/.el-button--mini {
            padding: 3px 8px;
            background-color: #F6F6F6;
            color: #666;
            border: 1px solid #F6F6F6;
          }

          i {
            font-size: 16px;
          }
        }

        .item {
          display: flex;
          margin-left: 65px;
          line-height: 40px;

          .el-icon-copy-document {
            line-height: 40px;
          }

          span {
            margin-right: 10px;
          }

          .acli {
            cursor: pointer;
            color: #f9ff57;
            text-decoration: underline;
          }
        }
      }

      .total {
        display: flex;
        flex-wrap: wrap;
        padding: 12px 0;

        .label {
          margin-right: 60px;
        }

        .item {
          margin-right: 36px;

          span {
            margin-left: 10px;
            color: #F9FF57;
          }
        }
      }
    }
  }

  .noData {
    padding: 20px 0;
    text-align: center;
  }
}

/deep/ .el-textarea__inner {
  height: 80px;
  padding: 0 2px;
  line-height: 18px;
}

.num-color {
  span {
    color: #c35257;


  }

  .complete {

    color: #2C96E7;

  }
}

.btn {
  display: flex;
  justify-content: space-between;
  padding: 24px;
  margin: 24px 0;
  background-color: #F8F8F8;
  position: sticky;
  left: 0;
  bottom: 0;

  .left {
    line-height: 40px;
    margin-left: 10px;

    .el-button {
      margin-left: 50px;
    }
  }
}

.bottom {
  display: flex;
  padding: 24px;
  background-color: #F8F8F8;

  .bottom-left {
    width: 900px;
    margin-right: 24px;
  }

  .label {
    margin-bottom: 16px;

  }

  .text {
    width: 100%;


    /deep/.el-textarea__inner {
      height: 120px;
    }
  }

  .file {
    flex: 1;
    display: flex;

    /deep/.el-upload-dragger {
      width: 120px;
      height: 120px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px dashed #ccc;
      border-radius: 4px;

      i {
        font-size: 30px;
      }
    }

    .file-list {
      i {
        font-size: 100px;
        margin-right: 20px;
        color: #b4272d;
      }
    }
  }
}



// 标签信息列与检品详情保持一致，固定宽度避免标签内容被挤压。
.tagCell {
  flex: 0 0 240px !important;
  min-width: 240px;
}

// 多个标签按照接口顺序从上往下排列。
.tagCell.tagListCell {
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
}

.tag-content {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  // 单个标签使用白色背景，与检品详情的标签展示保持一致。
  background-color: #fff;
}

.tag-actions {
  // 核对按钮靠左、打印按钮靠右。
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.tag-record {
  width: 100%;
  border: 1px solid #b5b5b5;
}

.tag-field {
  display: flex;
  min-height: 22px;
  border-bottom: 1px solid #b5b5b5;

  &:last-child {
    border-bottom: none;
  }
}

.tag-label {
  // 固定字段名宽度，完整显示“文本描述1”等名称。
  flex: 0 0 96px;
  box-sizing: border-box;
  padding: 2px 4px;
  background: #f5f5f5;
  border-right: 1px solid #b5b5b5;
  white-space: nowrap;
}

.tag-value {
  flex: 1;
  min-width: 0;
  padding: 2px 4px;
  word-break: break-all;
}

// 标签数量和纯文本标入口同排展示，保持与配送单一致。
.tag-count-value {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  word-break: normal;

  .el-button {
    flex: none;
    margin-left: 0;
  }
}
</style>
